import { _ } from '../utils.js'
import Swiper, { Autoplay, Scrollbar, Thumbs, FreeMode } from 'swiper'

export default class SwiperSlider {
    constructor(el) {
        this.el = el

        this.autoplay = this.el.getAttribute('data-swipeautoplay')
            ? true
            : false
        this.nav = _(this.el.dataset.nav, 'element').node()
        this.peak = this.el.getAttribute('data-peak') ? true : false
        this.largeCards = this.el.getAttribute('data-large-cards')
            ? true
            : false
        this.random = this.el.getAttribute('data-random') ? true : false
        this.scrollbar = _(this.el.dataset.scrollbar, 'element').node()
        this.slides = _('swiperSlide', 'element').nodesFrom(this.el)

        // data-element="refresh-slider" - called from simple-filter, targets the div inside the browse-solutions slider
        this.refreshSlider = _('refresh-slider', 'element').node(this.el)
        this.refreshSlider?.addEventListener('change', this.updateSwiper)

        this.breakpoints = {
            319: {
                slidesPerView: this.peak ? 1 : 1,
            },
            567: {
                slidesPerView: this.peak ? 2 : 1,
            },
            768: {
                slidesPerView: this.peak ? 3 : 1,
            },
            1024: {
                slidesPerView: this.peak ? 4 : 1,
            },
        }

        // random starting slide
        if (this.random) {
            this.initialSlide = Math.floor(Math.random() * this.slides.length)
        } else {
            this.initialSlide = 0
        }

        if (this.nav) {
            this.navSwiper = new Swiper(this.nav, {
                initialSlide: this.initialSlide,
                slidesPerView: 'auto',
                slidesOffsetAfter: 30,
                spaceBetween: 30,
                updateOnWindowResize: true,
                watchSlidesProgress: true,
            })
        }

        if (this.largeCards) {
            this.breakpoints = {
                319: {
                    slidesPerView: this.peak ? 1 : 1,
                },
                567: {
                    slidesPerView: this.peak ? 1 : 1,
                },
                768: {
                    slidesPerView: this.peak ? 2 : 1,
                },
                1024: {
                    slidesPerView: this.peak ? 3 : 1,
                },
            }
        }

        this.swiper = new Swiper(this.el, {
            modules: [Autoplay, Scrollbar, Thumbs, FreeMode],
            autoHeight: this.peak ? false : true,
            autoplay: this.autoplay
                ? { delay: 3000, disableOnInteraction: true }
                : false,
            centeredSlides: this.peak ? false : true,
            freeMode: this.peak ? true : false,
            initialSlide: this.initialSlide,
            preventClicks: true,
            preventClicksPropagation: true,
            slidesPerView: this.peak ? 'auto' : 1,
            spaceBetween: this.peak ? 20 : 0,
            scrollbar: this.scrollbar
                ? { el: '.swiper-scrollbar', hide: false, draggable: true }
                : false,
            thumbs: this.nav ? { swiper: this.navSwiper } : null,
            updateOnWindowResize: true,
            watchSlidesProgress: true,
            breakpoints: this.breakpoints,
        })
    }

    updateSwiper = () => {
        // timeout is for swiper, as it doesn't work without the delay
        setTimeout(() => {
            this.swiper.update()
            this.swiper.setProgress(0)
        }, 100)
    }
}
